import IPostMessage from '../IPostMessage';
import Mdc from './MDC/Mdc';
import Nmc from './NMC/Nmc';

/**
 * The `sos.native` API groups together methods for controlling the device using native commands.
 */
export default class NativeCommands {
	public static MESSAGE_PREFIX: string = 'native_commands';

	public readonly mdc: Mdc;
	public readonly nmc: Nmc;

	/** @internal */
	constructor(
		private messagePrefix: string,
		private postMessage: IPostMessage<any>,
	) {
		this.mdc = new Mdc(this.getMessagePrefix(), this.postMessage);
		this.nmc = new Nmc(this.getMessagePrefix(), this.postMessage);
	}

	private getMessagePrefix() {
		return this.messagePrefix + '.' + NativeCommands.MESSAGE_PREFIX;
	}
}
